import { Navigate } from "react-router";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { EndorsementExtraCoveragesCustomization } from "./ExtraCoverages/EndorsementExtraCoveragesCustomization";
import { PersonalizedPlanSection } from "./PersonalizedPlan/PersonalizedPlanSection";
import { UnderwritingSection } from "./Underwriting/UnderwritingSection";
import { useCoverageStep } from "./useCoverageStep";

import { SectionCard } from "../SectionCard";
import { ViewOnlyNotice } from "../ViewOnlyNotice";

export function CoverageStep() {
  const { viewOnly, redirectTo, extraCoverages } = useCoverageStep();

  if (redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <Box
      data-testid="coverage-step-content"
      display="flex"
      flexDirection="column">
      {viewOnly && <ViewOnlyNotice />}
      <PersonalizedPlanSection />
      <SectionCard title="Extra Coverages" dataTestId="extra-coverages-section">
        {extraCoverages.length > 0 ? (
          <EndorsementExtraCoveragesCustomization
            coverages={extraCoverages}
            viewOnly={viewOnly}
          />
        ) : (
          <Typography color="text.secondary">
            No extra coverages are available for this policy.
          </Typography>
        )}
      </SectionCard>
      <UnderwritingSection />
    </Box>
  );
}
